import { defineStore } from 'pinia'
import { services } from '@/assets/js/config.js'
import { useHttpStore } from './httpStore';


export const useAccessControlStore = defineStore('accessControlStore', {
	state: () => ({
		userList: []
	}),
	getters: {
    loanOfficerList(){
			if(_gHlp.isEmpty(this.userList)){
				return []
			}
			return this.userList.filter(item => {
					const statusActive = item.status == 1 ? true : false;
					// Check if any of the item's addresses match the filter criteria
					const hasRole = item.roles && item.roles.some(role => {
						let intersect = _.intersection(role.role_access,['role_loan_officer']);
						return (role.application_code == _gAuth.appCode()) && (intersect.length > 0);
					}) ? true : false;
				
					// Return true if both conditions are met, otherwise false
					return statusActive && hasRole;
			});
		},
    ssaList(){
			if(_gHlp.isEmpty(this.userList)){
				return []
			}
			return this.userList.filter(item => {
					const statusActive = item.status == 1 ? true : false;
					// Check if any of the item's addresses match the filter criteria
					const hasRole = item.roles && item.roles.some(role => {
						let intersect = _.intersection(role.role_access,['role_ssa', 'role_sales_advisor_manager', 'role_sse', 'role_sales_support_manager', 'role_sales_executive']);
						return (role.application_code == _gAuth.appCode()) && (intersect.length > 0);
					}) ? true : false;
				
					// Return true if both conditions are met, otherwise false
					return statusActive && hasRole;
			});
		},
    sseList(){
			if(_gHlp.isEmpty(this.userList)){
				return []
			}
			return this.userList.filter(item => {
					const statusActive = item.status == 1 ? true : false;
					// Check if any of the item's addresses match the filter criteria
					const hasRole = item.roles && item.roles.some(role => {
						let intersect = _.intersection(role.role_access,['role_sse','role_sales_support_manager']);
						return (role.application_code == _gAuth.appCode()) && (intersect.length > 0);
					}) ? true : false;
				
					// Return true if both conditions are met, otherwise false
					return statusActive && hasRole;
			});
		}
  },
	actions: {
		getUsers(params) {
			const httpStore = useHttpStore();
      return new Promise((resolve, reject) => {
        httpStore.get(`${services.access_control}user`, params).then((resp) => {
					this.userList = _gHlp.patchData(_gHlp.getLocalStorage('access_control.users',[]), resp.data.data, 'id');
					_gHlp.setLocalStorage('access_control.users',this.userList);
					resolve(resp.data.data);
        })
      });
		},
		getUser(id, attr='all', retDef = null) {
			if(_gHlp.isEmpty(id)) return retDef;
			this.userList = _gHlp.getLocalStorage('access_control.users',[]);

			let user = this.userList.find(item=>{
				return item.id == id;
			})
			if(_gHlp.isEmpty(user)){
				user = this.getUsers({user_ids:[id]}).then(resp => {
					if(_gHlp.isEmpty(resp)){
						return resp[0];
					}else{
						return null;
					}
				})
			}
			
			if(_gHlp.isEmpty(user)) return retDef;
			if(attr != 'all'){
				return _gHlp.getValue(user,attr,retDef);
			}else{
				return user
			}
		}
	}
})